export default __webpack_public_path__ + "static/media/ic-facebook.e44ca690.svg";